var $ = global.jQuery = global.$;

var widgets = require('../lib/widgets');

require('jquery-validation');

var _Base = require('./_Base');

/**
 * Form widget
 * @class
 * @extends _Base
 */
var Form = _Base.extend(
  /** @lends Form.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.fields = {};
    this.isDisabled = false;

    this.$el.on('Field:updated', this, function(event, name, value) {
      self._fieldRegistryUpdate.call(self, event, name, value);
    });

    // this.$el.on('submit', this._formSubmitHandler.bind(this));
  },
  onWidgetsReady: function() {
    var customValidation = {
      errorPlacement: function(error, element) {
        var dateField = $(element).parents('.date-selects');
        var customSelect = $(element).parents('[data-widget=CustomSelect]');
        if (dateField.length) {
          dateField.append(error);
        } else if (customSelect.length) {
          error.insertAfter(customSelect);
        } else {
          error.insertAfter(element);
        }
      }
    };
    this.$el.validate(customValidation);
  },
  /**
   * Handle form submission
   * @private
   */
  _formSubmitHandler: function(event) {
    event.preventDefault();
    if (this.isDisabled === false) {
      this.$el.trigger('Form:submitted', [this.getFieldValues()]);
    }
  },
  /**
   * Update field registry
   * @private
   */
  _fieldRegistryUpdate: function(event, name, value) {
    event.stopPropagation();
    this.fields[name] = {};
    this.fields[name].value = value;
  },
  /**
   * Set values of the forms fields to the new values
   * @param {Object} newValues - An object of key value pairs corresponding to field names and values to update.
   */
  setFieldValues: function(newValues) {
    for (var fieldName in newValues) {
      if (newValues.hasOwnProperty(fieldName)) {
        var $field = widgets.registry[$('[name=' + fieldName + ']').closest($('[data-widget]')).attr('id')];
        $field.setValue(newValues[fieldName]);
      }
    }
  },
  /**
   * Get values of all child fields
   * @returns {Object} An object of key value pairs of form field values
   */
  getFieldValues: function() {
    var fields = {};
    for (var fieldName in this.fields) {
      if (this.fields.hasOwnProperty(fieldName)) {
        fields[fieldName] = this.fields[fieldName].value;
      }
    }
    return fields;
  }
});

module.exports = Form;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Form.js
 ** module id = 13
 ** module chunks = 0 1
 **/